import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { ProgressBarComponent, TooltipDirective } from '@ui';
import { ItemLossesBalanceParams } from '@data';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-losses-balance-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProgressBarComponent,
    TooltipDirective,
    TranslocoDirective,
    TranslocoDecimalPipe,
  ],
  template: `
    <div class="grid grid-cols-12 gap-x-3 min-h-[44px] items-center">
      <div class="col-span-3">
        <span class="text-neutral-7">
          <span
            class="text-xs font-medium uppercase duration-300 transition-colors h-5 max-w-[75%] text-ellipsis whitespace-nowrap overflow-hidden cursor-pointer hover:text-tertiary"
            (click)="emitLostCenter()"
          >
            {{ item().centerName }}
          </span>
        </span>
      </div>
      <div class="col-span-1 text-center">
        <span
          class="text-amber-700 bg-amber-100 rounded-full px-2 py-1 font-medium"
          >{{ percent() | translocoDecimal }}%</span
        >
      </div>
      <div class="col-span-8">
        <ui-progress-bar
          uiTooltip
          [tooltipTitle]="nameTemplate"
          colorClass="bg-blue-500"
          bgColorClass="bg-sky-200"
          height="h-[8px]"
          [progress]="progress()"
        />
      </div>
    </div>

    <ng-template #nameTemplate>
      <div *transloco="let t" class="text-xs">
        {{ t('CHARTS.LOSSES.LEGEND_CT') }}: {{ item().energyCT }} <br />
        {{ t('CHARTS.LOSSES.LEGEND_ENERGY') }}: {{ item().consumption }} <br />
        {{ t('CHARTS.LOSSES.TITLE') }}: {{ item().losses }}
      </div>
    </ng-template>
  `,
})
export class LossesBalanceItemComponent {
  item = input.required<ItemLossesBalanceParams>();
  isBold = input<boolean>(false);
  progress = computed(() =>
    this.item().losses <= 100 ? this.item().losses : 100,
  );

  // percent formatted to 2 decimals
  percent = computed(() => {
    const energy = this.item().energyCT ?? 0;
    if (!energy) return '0.00';
    const value = (this.item().losses / energy) * 100;
    if (!isFinite(value)) return '0.00';
    return value.toFixed(2);
  });

  onCenter = output<{
    distributorId: string;
    centerId: string;
    rsabtId?: string;
    tsabtId?: string;
    vtnId?: string;
  }>();

  emitLostCenter() {
    this.onCenter.emit({
      distributorId: this.item().distributorId,
      centerId: this.item().centerId,
      rsabtId: this.item().rsabtId,
      tsabtId: this.item().tsabtId,
      vtnId: this.item().vtnId,
    });
  }
}
